<template>
  <div class="grey lighten-2 mb-2 mt-2 mx-2" style="height: 1px; width: 100%"></div>
</template>

<script>
export default {};
</script>

<style>
</style>
